export const url = 'https://ws.teknobay.com.tr/AsilMobile/'
export const sayfalar = `${url}sayfalar/MA==`
export const giris = `${url}uyeGirisi/`
export const sifremiunuttum = `${url}uyeSifremiUnuttum/`
export const kayitol = `${url}uyeKayitOl/`
export const slider = `${url}slider/`
export const vitrin = `${url}vitrinKategoriListeleme/Mw==`
export const bakiye = `${url}bakiyeBilgisi/`
export const puanbilgisi = `${url}puanBilgisi/`
export const solmenu = `${url}urunKategorileriSolMenu/MA==`
export const urunlisteleme = `${url}urunListeleme/`
export const urundetay = `${url}urunDetay/`
export const sepetigetir = `${url}sepetiGetir/`
export const bankagetir = `${url}bankaHesap`
export const krediKartlari = `${url}krediKartlari`
export const taksitleriGetirKartla = `${url}taksitleriGetirKartla/`
export const siparistamamlaozel = `${url}siparisTamamlaOzel/`
export const aramayap = `${url}AramaYap/`
export const uyebilgileri = `${url}uyeProfilBilgileri/`
export const siparisgecmisi = `${url}siparisGecmisi/`
export const siparisdetay = `${url}siparisDetayGetir/`
export const musteriadresler = `${url}musteriAdresListesi/`
export const musteriadressil = `${url}musteriAdresiSil/`
export const adresigetir = `${url}musteriAdresiGetir/`
export const adresduzenle = `${url}musteriAdresDuzenle/`
export const musteriadresaydet = `${url}musteriAdresKaydet/`
export const uyeProfilBilgileriGuncelle = `${url}uyeProfilBilgileriGuncelle/`
export const odemeGecmisi = `${url}odemeGecmisi/`
export const sepeteekle = `${url}sepeteEkle/`
export const sepettensil = `${url}sepettenSil/`
export const sepetiBosalt = `${url}sepetiBosalt/`
export const odemeTutarlari = `${url}odemeTutarlari/`
export const siparisTamamlaKKarti = `${url}siparisTamamlaKKarti/`
export const siparisTamamlaHavale = `${url}siparisTamamlaHavale/`
export const odemeTutarlariHavale = `${url}odemeTutarlariHavale/`
export const odemeTutarlariCari = `${url}odemeTutarlariCari/`
export const siparisTamamlaCari = `${url}siparisTamamlaCari/`
export const musteriAdreslerineGoreKargoFiyati = `${url}musteriAdreslerineGoreKargoFiyati/`
export const uyeSilme = `${url}uyeSilme/`
export const sehirIlceGetir = `${url}sehirIlceGetir/`
export const akinsofttanBakiyeSorgulaSite = `${url}AkinsofttanBakiyeSorgulaSite/`
export const markalarGetir = `${url}markalarGetir`
export const markaUrunListeleme = `${url}markaUrunListeleme/`
